var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.bannerSrc
      ? _c("img", {
          staticClass: "opacity-100 mx-auto",
          attrs: {
            alt: _vm.domainConfig.company_name + " banner",
            src: _vm.bannerSrc
          }
        })
      : _vm._e(),
    _vm.campaigns.length
      ? _c(
          "div",
          { staticClass: "container mx-auto my-2 md_my-4" },
          [
            _c("product-group", {
              attrs: {
                "is-whitelabel": "is-whitelabel",
                center: "center",
                wrap: "wrap",
                "full-width-images": "full-width-images",
                campaigns: _vm.campaigns,
                "currency-info": _vm.currencyInfo
              }
            }),
            _c("pagination", { attrs: { page: _vm.page } })
          ],
          1
        )
      : !_vm.processing
      ? _c(
          "div",
          { staticClass: "container mx-auto" },
          [
            _c("vs-alert", {
              staticClass: "mt-4",
              attrs: { message: "No products found..." }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }